(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var panel = document.querySelector('[data-detail-panel]');
  var tabsEl = document.querySelector('[data-detail-panel-tabs]');
  var bodyEl = document.querySelector('[data-detail-panel-body]');
  if (!panel || !tabsEl || !bodyEl) return;

  var sections = [];
  var activeIndex = 0;

  function buildSections() {
    sections = [];
    document.querySelectorAll('.product-accordion').forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-collapsible-trigger]');
      var content = accordion.querySelector('[data-collapsible-content]');
      if (!trigger || !content) return;

      var clone = trigger.cloneNode(true);
      var icon = clone.querySelector('.icon');
      if (icon) icon.remove();

      sections.push({
        title: clone.textContent.trim(),
        html: content.innerHTML
      });
    });
  }

  function renderTabs(index) {
    tabsEl.innerHTML = sections.map(function (s, i) {
      return '<button class="detail-panel__tab' + (i === index ? ' is-active' : '') + '" data-detail-tab="' + i + '">' + s.title + '</button>';
    }).join('');

    tabsEl.querySelectorAll('[data-detail-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        renderContent(parseInt(btn.dataset.detailTab, 10));
      });
    });
  }

  function renderContent(index) {
    activeIndex = index;
    renderTabs(index);
    bodyEl.innerHTML = sections[index] ? sections[index].html : '';
  }

  function openPanel(index) {
    buildSections();
    if (!sections.length) return;
    renderContent(index);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.product-accordion').forEach(function (accordion, i) {
    var trigger = accordion.querySelector('[data-collapsible-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openPanel(i);
    }, true);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-detail-panel-close]')) closePanel();
    if (e.target.closest('[data-detail-panel-overlay]')) closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });
})();
